<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            {{each field.listOriginal}}
            <div class="form-row">
                <div class="c-form-select" skf-options="{{$index}}" skf-class="$index > 0 ? 'c-form-select u-mt8': 'c-form-select'">
                    <div class="select-menu">
                        <div class="select-value" skf-options="{{$index}}" skf-text="$field.value[$index] || '请选择'"></div>
                        <div class="select-tips"></div>
                    </div>
                    <ul class="select-main">
                        {{each $value $data $cIndex}}
                        <li skf-if="$field.listOriginal[{{$index}}][{{$cIndex}}].isNotShow != 1"
                            skf-click="$parent.clickList('{{$data.optionId}}', '{{field.fieldName}}',{{$index}})">
                            <span class="select-text">
                                {{$data.optionValue}}
                            </span>
                        </li>
                        {{/each}}
                    </ul>
                </div>
            </div>
            {{/each}}

            <div class="form-row form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage"></div>

        </div>
    </div>
</div>